/*
 * JSライブラリ Swiper を使用
 *   https://swiperjs.com/
 *
 * ".swiper-container"  Swiperの領域（ページネーション・スクロールなども含む）
 * ".swiper-slide"      スライド部分、スライドさせる物の分だけ要素につける
 * ".swiper-pagination" ページネーション要素を指定(デフォルト)。任意のクラスを与えられる
 */
import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', () => {
  let swiper;
  setSwiper();
  function setSwiper() {
    if($('.top-slider-banner > .swiper-slide').size() == 1) {
      // TOPスライドバナーが1つのとき
      swiper = new Swiper('.swiper-container-top-slider-banner', {
        centeredSlides: true,
        watchOverflow: true,
      });
    } else {
      swiper = new Swiper('.swiper-container-top-slider-banner', {
        centeredSlides: true,
        loop: true,
        speed: 500,
        slidesPerView: 1.2,
        spaceBetween: 10,
        breakpoints: {
          641: {
            slidesPerView: 1.35,
            spaceBetween: 20
          }
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.main_v_right',
          prevEl: '.main_v_left',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
      });
    };
  };
});
